import IComponent from "components/commons/IComponent";
import "./DetailPanels.scoped.css";
import DownloadFromWebAPI from "../../../utils/DownloadFromWebAPI";

import { dataProcessFunctions } from "./dataProcessFunctions";
import ReactInnerText from "utils/ReactInnerText";

class CheckingStatusInfo extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      checkingStatus: [
        {
          alias: "Checking Status",
          field: "CheckingStatusInformations",
          value: "",
          displayTemplate: [
            {
              alias: "Tagmark",
              field: "TAGMARK",
              value: [],
              isClickable: true,
            },
            {
              alias: "Part",
              field: "PART",
              value: [],
            },
            {
              alias: "Checking Status",
              field: "CHECKSTATUS",
              value: [],
            },
            {
              alias: "Checking Certificate No.",
              field: "CHECKCERT",
              value: [],
            },
          ],
        },
      ],
      SCS: [
        {
          alias: "SCS ID",
          field: "TAGMARK",
          value: "",
        },

        {
          alias: "SCS Feature",
          field: "FEATURE",
          value: "",
        },
        {
          alias: "SCS Part",
          field: "PART",
          value: "",
        },
        {
          alias: "SCS Status",
          field: "FK_STATUS",
          value: "",
        },
        {
          alias: "Checking Status",
          field: "DESCRIPTION",
          value: "",
        },
        {
          alias: "Check Cert",
          field: "CHECKCERT",
          value: "",
        },
        {
          alias: "Feature Remark",
          field: "REMARKS",
          value: "",
        },
        {
          alias: "Reviewer",
          field: "NAME",
          value: "",
        },
        {
          alias: "GEO Reply",
          field: "GEOREPLYDATE",
          value: "",
        },
        {
          alias: "Last Update",
          field: "LASTUPDATEDATE",
          value: "",
        },
        {
          alias: "Easting",
          field: "EASTING",
          value: "",
        },
        {
          alias: "Northing",
          field: "NORTHING",
          value: "",
        },
        {
          alias: "---------------",
          field: "",
          value: "",
        },
        {
          alias: "File Ref",
          field: "PROJECTREF",
          value: "",
        },
        {
          alias: "ERKS File Ref",
          field: "ERKS_PROJECTREF",
          value: "",
        },
        {
          alias: "File Title",
          field: "PROJECTTITLE",
          value: "",
        },
        {
          alias: "Project Type",
          field: "PROJECTTYPE",
          value: "",
        },
        {
          alias: "File Ref Image",
          field: "IMAGENAMEs",
          value: "",
        },
      ],
      FSR: [
        {
          alias: "SCS ID",
          field: "TAGMARK",
          value: "",
        },
        {
          alias: "SIS Feature",
          field: "FEATURE",
          value: "",
        },
        {
          alias: "SCS Feature",
          field: "FEATURE",
          value: "",
        },
        {
          alias: "SCS Part",
          field: "PART",
          value: "",
        },
        {
          alias: "SCS Status",
          field: "SCS_STATUS",
          value: "",
        },
        {
          alias: "FSR Status",
          field: "FK_CHECKING_STATUS",
          value: "",
        },
        {
          alias: "Feature Remark",
          field: "FEA_REMARKS",
          value: "",
        },
        {
          alias: "Feature Action",
          field: "ACTIONS",
          value: "",
        },
        {
          alias: "Reviewer",
          field: "GENAME",
          value: "",
        },
        {
          alias: "Last Update",
          field: "FEATURE_LASTUPDATEDATE",
          value: "",
        },
        {
          alias: "File Ref",
          field: "FILE_ID",
          value: "",
        },
        {
          alias: "File Title",
          field: "TITLE",
          value: "",
        },
        {
          alias: "Project Type",
          field: "BPUBLIC",
          value: "",
        },
        {
          alias: "File Remark",
          field: "FIL_REMARKS",
          value: "",
        },
        {
          alias: "Relevant File",
          field: "RELEFILES",
          value: "",
        },
        {
          alias: "Easting",
          field: "EASTING",
          value: "",
        },
        {
          alias: "Northing",
          field: "NORTHING",
          value: "",
        },
        {
          alias: "Hotlink",
          field: "PDFs",
          value: "",
        },
      ],
      isFSR: false,
    };
  }

  exportToPdf(title, attr) {
    // evt.stopPropagation();
    console.debug(title, attr);
    attr = attr.map((i) => {
      let row = {};
      ["Name", "Value"].forEach((attrName) => {
        console.debug(i[attrName]);
        row[attrName] = ReactInnerText(i[attrName]);
      });
      return row;
    });
    title = encodeURI(title);
    attr = encodeURI(JSON.stringify(attr));
    let tempForm = document.createElement("FORM");
    tempForm.method = "post";
    tempForm.target = "_blank";
    tempForm.action = this.$config.baseUrl + "/GInfoMap/export.aspx";
    tempForm.innerHTML = `<input type="hidden" name="title" value="${title}"/><input type="hidden" name="json" value="${attr}"/>`;
    document.body.appendChild(tempForm);
    tempForm.submit();
    document.body.removeChild(tempForm);
  }
  render() {
    return (
      <div>
        <div className="SubPanelTitle">Basic Information</div>

        {this.state.checkingStatus[0].displayTemplate[0].value.map(
          (section, secIndex) => {
            return (
              <>
                <table className="ResultInfoTable">
                  <tbody>
                    {this.state.checkingStatus[0].displayTemplate.map(
                      (i, j) => (
                        <tr
                          key={`checkingStatus_` + j}
                          className="ResultInfoRow"
                        >
                          <td className="ResultInfoRowHead">{i.alias}</td>
                          <td className="ResultInfoRowValue">
                            {"isClickable" in i ? (
                              <div
                                className="hyperlink"
                                onClick={() =>
                                  this.openSCS(i.value[secIndex], secIndex)
                                }
                              >
                                {i.value[secIndex]}
                              </div>
                            ) : (
                              i.value[secIndex]
                            )}
                            {i.alias === "Part" && (
                              <p>
                                Note: 0 for whole feature. 1, 2, 3...for part
                                (not MR sub-division) of the feature.
                              </p>
                            )}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
                <hr />
              </>
            );
          }
        )}
      </div>
    );
  }
  componentDidMount() {
    this.props.isShowTabCallback(true);
    let dataProcessClassObj = new dataProcessFunctions();

    let tmpCheckingStatus = Object.assign([], this.state.checkingStatus);
    tmpCheckingStatus = dataProcessClassObj.assignCellValueWithClick(
      tmpCheckingStatus,
      this.props.attributes
    );
    this.setState({ checkingStatus: tmpCheckingStatus });
  }
  async openSCS(scsCode, idx) {
    let isFSR =
      this.props.attributes.CheckingStatusInformations[idx].TYPE === "FSR";
    this.setState({ isFSR });
    if (this.props.text !== "") {
      let url = isFSR
        ? this.$config.ManMadeSlopeInfoList.FSRUrl
        : this.$config.ManMadeSlopeInfoList.SCSUrl;
      let data = {
        Key: scsCode,
      };
      let querySCSResults = await this.fetchQueryByPOST(url, data);
      var finalSCSResult = await querySCSResults.json();
      let finalResult = finalSCSResult;
      if (finalResult.PK_ID !== "N/A") {
        let tmpTemplate = Object.assign(
          [],
          isFSR ? this.state.FSR : this.state.SCS
        );

        console.log(tmpTemplate);
        tmpTemplate.forEach((i, index) => {
          Object.keys(finalResult).forEach((j) => {
            if (typeof i.field === "string" && j === i.field) {
              tmpTemplate[index]["value"] = finalResult[j];
              return;
            } else if (i.field === "FEATURE") {
              tmpTemplate[index]["value"] = this.props.text;
            } else if (i.field === "TAGMARK") {
              tmpTemplate[index][
                "value"
              ] = this.state.checkingStatus[0].displayTemplate
                .filter((iTemplate) => iTemplate.field === i.field)
                .map((iTemplate) => iTemplate.value[idx]);
            }
          });
        });
        this.state.isFSR
          ? this.setState({ FSR: tmpTemplate })
          : this.setState({ SCS: tmpTemplate });

        let form = () => {
          const dataToTransform = this.state[this.state.isFSR ? "FSR" : "SCS"];

          let display_use = [];
          let pdf_use = [];

          dataToTransform.map((item) => {
            // Apply the same conditions as in your original code

            const value_display = (() => {
              if (item.alias === "SIS Feature") {
                return item.value.replace(/\s+/g, "");
              } else if (item.alias === "---------------") {
                return "---------------";
              } else if (item.alias === "Hotlink" && item.value.length > 0) {
                return item.value.map((j) => (
                  <a href={DownloadFromWebAPI(j.URL)} target="_blank">
                    PDF
                  </a>
                ));
              } else if (
                item.alias === "File Ref Image" &&
                item.value.length > 0
              ) {
                return item.value.map((j) => (
                  <a href={DownloadFromWebAPI(j.URL)} target="_blank">
                    Open Image
                  </a>
                ));
              } else if (Array.isArray(item.value) && item.value.length === 0) {
                return "N/A";
              } else {
                return item.value;
              }
            })();

            const value_pdf = (() => {
              if (item.alias === "SIS Feature") {
                return item.value.replace(/\s+/g, "");
              } else if (item.alias === "---------------") {
                return "---------------";
              } else if (item.alias === "Hotlink" && item.value.length > 0) {
                return "PDF";
              } else if (
                item.alias === "File Ref Image" &&
                item.value.length > 0
              ) {
                return "Open Image";
              } else if (Array.isArray(item.value) && item.value.length === 0) {
                return "N/A";
              } else {
                return item.value;
              }
            })();

            // Return the transformed object
            display_use.push({
              alias: item.alias,
              value: value_display,
            });

            pdf_use.push({
              Name: item.alias,
              Value: value_pdf,
            });
          });

          this.props.showDialog({
            isOpen: true,
            content: (
              <div>
                <div className="ResultInfoTableHeader">
                  <span>
                    {this.state.isFSR
                      ? "Feature Status Review"
                      : "Slope Checking Status"}
                  </span>
                </div>
                <table className="ResultInfoTable">
                  <tbody>
                    {display_use.map((i, j) => {
                      return (
                        <tr
                          key={`checkingStatus_` + j}
                          className="ResultInfoRow"
                        >
                          <td className="ResultInfoRowHead">{i.alias}</td>
                          <td className="ResultInfoRowValue">{i.value}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <div
                    style={{ cursor: "pointer", width: "0%" }}
                    onClick={() => {
                      let title = this.state.isFSR
                        ? "Feature Status Review"
                        : "Slope Checking Status";
                      this.exportToPdf(title, pdf_use);
                      // this.exportToPdf("Slope Checking Status", pdf_use);
                    }}
                  >
                    <span className="icn_pdf" style={{ padding: "20px" }} />
                  </div>
                </table>
              </div>
            ),
            onDialogOk: () => {},
          });
        };

        this.state.isFSR
          ? form()
          : this.props.showDialog({
              isOpen: true,
              title: "ginfo.cedd.hksarg says",
              content: (
                <div>
                  For viewing of the extent of slope feature checked up to
                  current standard, please check the "Slope Checking
                  Status(SCS)" layer in Map Content of the Ginfo Menu.
                </div>
              ),
              onDialogOk: () => {
                form();
                return false;
              },
              onDialogCancel: () => {},
            });
      }
    }
  }
}
export default CheckingStatusInfo;
